import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import Vuelidate from "vuelidate/src";
import {Auth0Plugin} from "./auth";
import smoothScroll from "vue-smoothscroll";
import vueMathJax from "vue-mathjax";
import VueMarkdown from 'vue-markdown'
import * as Sentry from "@sentry/browser";
import * as Integrations from '@sentry/integrations';
import VueCookies from 'vue-cookies'
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  redirectUri: process.env.VUE_APP_AUTH0_REDIRECT_URL,
  audience: process.env.VUE_APP_API_SERVER_BASE_URL,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});
Vue.use(smoothScroll);
Vue.use(vueMathJax);
Vue.use(VueCookies)
Vue.component(VueCropper);

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SNETRY_DSN,
  integrations: [
    new Integrations.Vue({Vue, attachProps: true})
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV
})

Vue.config.errorHandler = (error) => {
  if (process.env.NODE_ENV !== 'local') {
    Sentry.captureException(error);
  }
  throw error
}

new Vue({
  components: {
    VueMarkdown
  }
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app');
